<ng-container *transloco="let t">
    <div class="container">
        <div fxLayout="column" fxLayoutAlign="space-around start">
            <div fxLayout="row wrap" fxLayoutAlign="space-around start">
                <div
                    fxFlex="940px"
                    fxLayoutAlign="space-between center"
                    fxFlex.xs="55"
                >
                    <h2>{{ t("support.privacy-policy.title") }}</h2>
                </div>
                <div
                    fxFlex="940px"
                    fxLayoutAlign="start center"
                    fxFlex.xs="55"
                ></div>
            </div>

            <mat-tab-group animationDuration="0ms">
                <mat-tab>
                    <ng-template mat-tab-label>
                        {{
                            t("support.privacy-policy.tabs.customer-privacy")
                        }}</ng-template
                    >
                    <ng-container>
                        <h3>
                            {{ t("support.privacy-policy.tabs.tab1.title") }}
                        </h3>
                        <p
                            [innerHTML]="
                                t('support.privacy-policy.tabs.tab1.p1')
                            "
                        ></p>
                    </ng-container>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</ng-container>
